import React from 'react'
import { connect } from 'react-redux'
import UpdateTransferencia from '../../../components/listados/movimientosExportadores/UpdateTransferencia'
import DeleteTransferencia from '../../../components/listados/movimientosExportadores/DeleteTransferencia'
import { deleteTransferenciaExportadores, updateTransferenciaExportadores } from '../../../actions/listados'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_TRANSFERENCIAS_EXPORTADOR } from '../../../../../config/forms'

function OperacionesTransferenciasExportador (props) {
  const { detalle, roles, deleteTransferenciaExportadores, updateTransferenciaExportadores } = props

  const rol = roles.filter(roles => roles === 'SUPERVISOR' || roles === 'DESARROLLADOR' || roles === 'OPSTOCK')
  const rolAutorizado = rol.length > 0

  const handleDelete = () => {
    deleteTransferenciaExportadores(detalle.id)
  }

  const handleUpdate = () => {
    const { exportadorOrigen, exportadorDestino, change: formChange } = props
    if (!exportadorOrigen) { formChange('exportadorOrigen', detalle.exportadorOrigen) }
    if (!exportadorDestino) { formChange('exportadorDestino', detalle.exportadorDestino) }
    updateTransferenciaExportadores(detalle.id)
  }

  return (
    <>
      { (rolAutorizado && detalle) &&
        <>
          <UpdateTransferencia detalle={detalle} handleUpdate={handleUpdate} />
          <DeleteTransferencia handleDelete={handleDelete} />
        </>
      }
    </>
  )
}

const selector = formValueSelector(FORM_TRANSFERENCIAS_EXPORTADOR)

const mapStateToProps = (state) => {
  return {
    exportadorOrigen: selector(state, 'exportadorOrigen'),
    exportadorDestino: selector(state, 'exportadorDestino'),
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  deleteTransferenciaExportadores,
  updateTransferenciaExportadores
}

const withReduxForm = reduxForm({
  form: FORM_TRANSFERENCIAS_EXPORTADOR,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(OperacionesTransferenciasExportador))
